import {connect} from 'react-redux';
import {isEmpty, isFunction} from 'lodash';
import {createStructuredSelector} from 'reselect';

import ProfileDetailsSection from '/component/partial/profile/ProfileDetailsSection';
import {
  PROFILE_FIELD_BUSINESS_COACH,
  PROFILE_FIELD_CERTIFIED,
  PROFILE_FIELD_HIGHEST_RANK,
  PROFILE_FIELD_OPTAVIA_ID,
  PROFILE_FIELD_RENEWAL_EXPIRY,
} from '/enum/profileField.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {
  businessCoachFullNameById,
  businessCoachIdById,
  highestAchievedRankDescriptionById,
  highestAchievedRankIdById,
  isCertifiedById,
  licenseExpiresOnById,
} from '/redux/selector/coach.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      businessCoachId: businessCoachIdById,
      businessCoachName: businessCoachFullNameById,
      highestRankId: highestAchievedRankIdById,
      highestRankDescription: highestAchievedRankDescriptionById,
      isCertified: isCertifiedById,
      renewExpiry: licenseExpiresOnById,
    }),
    null,
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fields: [
        PROFILE_FIELD_OPTAVIA_ID,
        PROFILE_FIELD_BUSINESS_COACH,
        PROFILE_FIELD_HIGHEST_RANK,
        PROFILE_FIELD_CERTIFIED,
        PROFILE_FIELD_RENEWAL_EXPIRY,
      ],
      optaviaId: ownProps.coachId,
      loggedInCoach: true,
      onBusinessCoachPress: isEmpty(stateProps.businessCoachId)
        ? null
        : () => {
            if (isFunction(ownProps.onBusinessCoachPress)) {
              ownProps.onBusinessCoachPress({
                businessCoachId: stateProps.businessCoachId,
              });
            }
          },
    }),
  ),
  withTranslation('screen.userProfile.section.details'),
)(ProfileDetailsSection);
